<!--
 * @Author: 317473294@qq.com
 * @Date: 2022-07-01 10:16:44
 * @LastEditTime: 2024-09-29 22:28:55
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/components/word/zdzy-dialog.vue
-->

<template>
    <div class="el-dialog">
        <el-dialog title="新增加单词" :visible.sync="dialogFormVisible" :before-close.stop="handleClose">
            <el-form :model="form">
                <el-form-item label="单词:" :label-width="formLabelWidth">
                    <el-input v-model="form.word" placeholder="请输入单词" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="记忆提示:" :label-width="formLabelWidth">
                    <Tinymce   v-model="form.tip"></Tinymce>
                </el-form-item>
                <!-- <el-form-item label="单词类型:" :label-width="formLabelWidth">
                    <el-select v-model="form.type" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="记忆提示:" :label-width="formLabelWidth">
                    <el-input type="textarea" :rows="2" placeholder="可选" v-model="form.tip"
                        autocomplete="off"></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="addNewWord">添加新单词</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { get, post } from "@/axios/index.js"
    import Tinymce from "@/components/tinymce/tinymce.vue";
// import {wordList,wordCreate,addWord} from "@/api/kyword.js"
    export default {
        name: "zdzyDialog",
        props: ['dialogFormVisible'],
        components:{
            Tinymce
        },
        data() {
            return {
                visbledia: this.dialogFormVisible,
                formLabelWidth: '150px',
                form:{
                    word:'',
                    tip:''
                }
            }
        },
        created() {
            // this.visbledia=this.dialogFormVisible
            // //console.log(this.dialogFormVisible)
        },
        computed: {

        },

        watch: {
            zdzylisdialog(val) {
                //console.log(val)
            }
        },
        methods: {
            show() {
                this.dialogFormVisible = true
            },
            //关闭
            handleClose() {
                this.$emit('onclose');
                this.form={
                    word:'',
                    tip:''
                }
                // this.dialogFormVisible = false
                // this.visbledia=false
            },
            addNewWord(data) {
                let word=this.form.word
           
                if(!word){
                    this.$message({
                    message: '请添加单词',
                    type: 'warning'
                    });
                    return
                }
                this.$emit("addNewWord",this.form)
         
            },
        }
    }
</script>
<style>
    .row-content {
        display: flex;
        flex-direction: column;


    }


    .classif-info {
        display: flex;
        text-align: left;
        font-size: 18px;
        font-weight: bold;
        font-weight: 400;
        color: #333333;
    }





    >>>.el-dialog__title {
        font-size: 18px;
        font-weight: bold;
        color: #2A354E;
    }

    .testcone {
        font-weight: 400;
        color: #0067F5;
        border: 1px solid #0067F5;
        border-radius: 4px 4px 4px 4px;
    }

    .input-with-select {
        display: flex;
        flex: 1;
    }

    >>>.el-radio {
        text-align: left;
        padding: 10px 0;
    }


    >>>.el-input__suffix {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px !important;
        cursor: pointer;
    }

    /*  */
    >>>.el-dialog__header {
        margin: 0;
        padding: 0;
        height: 50px;
        text-align: left;
    }

    >>>.el-dialog__title {
        position: relative;
        top: 20px;
        left: 20px;
    }

    >>>.el-form {
        /* height: 4rem; */
        position: relative;
        left:20px;
        margin-right: 150px;
    }

    >>>.el-dialog__footer {
        /* padding: 0 0.2rem; */
        text-align: left;
        margin-left: 170px;
        position: relative;
        top: -10px;
    }

    >>>.el-button--primary {
        background-color: #2CADD4;
    }

    >>>.el-input--suffix {
        display: flex;
        width: 100%;
    }

    >>>.el-select {
        display: flex;
        flex: 1;
    }
/* 在标签前面增加星号before，后面增加after */
/* 类名::before */
 >>>.el-form>div:nth-of-type(1)>label::before {
        content: ' *';
        color: red;
        font-size: 20px;
        position: relative;
        top: 5px !important;
    }
    >>>.el-form>div:nth-of-type(2)>label::before {
        content: ' *';
        color: red;
        font-size: 20px;
        position: relative;
        top: 5px !important;
    }
    /* 主要用于在dialog中，tinymce菜单栏在底部显示的问题 */
    .tox-tinymce-aux{z-index:999999999999 !important;}
.tinymce.ui.FloatPanel{z-Index: 9999999999 !important;}
</style>


// WEBPACK FOOTER //
// src/components/word/zdzy-dialog.vue